export enum TextTrackKinds {
	CAPTIONS = 'captions',
	CHAPTERS = 'chapters',
	DESCRIPTIONS = 'descriptions',
	METADATA = 'metadata',
	SUBTITLES = 'subtitles'
}
